<template>
  <main class="content">
    <Hero title="Contact"/>
    <div class="block maxw--waist text--center">
      <article class="rendered grande" v-html="$md.render(data?.content || '')"></article>
      <a class="mas-grande link link--primary" :href="`mailto:${data?.contactEmail}`">{{ data?.contactEmail }}</a>
    </div>
  </main>
</template>

<script lang="ts" setup>
import type ContactPage from '@/typings/strapi/pages/contactPage';

const { findOne } = useStrapi();

const { data } = await useAsyncData(
  'contact-page',
  () => findOne<ContactPage>('contact-page'),
  {
    transform: flattenObject
  }
)


useHead({
  title: 'Contact'
});

definePageMeta({
  pageTransition: pageTransitionConfig,
});
</script>
